export default __webpack_public_path__ + "static/samokat_product_4-c4c76fa2a253100889b78a974479cc64.png";